import { CommentDialogConfig } from '../comment-dialog/types/comment-dialog';

export const getRevisionCommentDialogConfig = (
  isMultiSelectEnabled: boolean,
): CommentDialogConfig => {
  const baseCommentTypes = [
    {
      id: 'donor-added',
      label: 'Donor Added',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Donor Name',
      additionalInputPlaceholder: 'Enter donor name',
      additionalInputRows: 1,
      additionalInputCols: 30,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
    {
      id: 'input-sire',
      label: 'Input Sire',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Sire Name',
      additionalInputPlaceholder: 'Enter sire name',
      additionalInputRows: 1,
      additionalInputCols: 30,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
    {
      id: 'change-sire',
      label: 'Change in Sire',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Sire Change Details',
      additionalInputPlaceholder: 'Enter "SireA" to "SireB"',
      additionalInputRows: 1,
      additionalInputCols: 40,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
    {
      id: 'change-semen-type',
      label: 'Change in Semen Type',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Semen Type Change',
      additionalInputPlaceholder: 'Enter "SemenTypeA to SemenTypeB"',
      additionalInputRows: 1,
      additionalInputCols: 40,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
    {
      id: 'change-semen-location',
      label: 'Change in Semen Location',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Location Change',
      additionalInputPlaceholder: 'Enter "from LocationA to LocationB"',
      additionalInputRows: 1,
      additionalInputCols: 40,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
    {
      id: 'change-semen-owner',
      label: 'Change in Semen Owner',
    },
    {
      id: 'change-collection-code',
      label: 'Change in Collection Code',
    },
    {
      id: 'split',
      label: 'Split',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'Split Details',
      additionalInputPlaceholder: 'Enter split details',
      additionalInputRows: 2,
      additionalInputCols: 30,
      customLogic: (baseComment: string, { additionalInputValue }: any) => {
        return `${baseComment}: ${additionalInputValue}`;
      },
    },
  ];

  const poolCommentType = {
    id: 'pool',
    label: 'Pool',
    requiresAdditionalInput: true,
    additionalInputType: 'number' as const,
    additionalInputLabel: 'Pool Number',
    additionalInputPlaceholder: 'e.g., 38279',
    secondaryInputType: 'textarea' as const,
    secondaryInputLabel: 'Sire Choice',
    secondaryInputPlaceholder: 'e.g., Here I Am',
    secondaryInputRows: 1,
    secondaryInputCols: 30,
    customLogic: (
      baseComment: string,
      { additionalInputValue, secondaryInputValue }: any,
    ) => {
      return `${baseComment} ${additionalInputValue}, sire choice ${secondaryInputValue}`;
    },
  };

  const otherCommentTypes = [
    {
      id: 'general-input',
      label: 'General Input',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'General Comment',
      additionalInputPlaceholder: 'Enter general comment',
      additionalInputRows: 3,
      additionalInputCols: 40,
    },
    {
      id: 'did-not-aspirate',
      label: 'Did Not Aspirate',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'General Comment',
      additionalInputPlaceholder: 'Enter additional details...',
      additionalInputRows: 3,
      additionalInputCols: 40,
    },
    {
      id: 'do-not-fert',
      label: 'Do Not Fert',
      requiresAdditionalInput: true,
      additionalInputType: 'textarea' as const,
      additionalInputLabel: 'General Comment',
      additionalInputPlaceholder: 'Enter additional details...',
      additionalInputRows: 3,
      additionalInputCols: 40,
    },
  ];

  const commentTypes = isMultiSelectEnabled
    ? [...baseCommentTypes, poolCommentType, ...otherCommentTypes]
    : [...baseCommentTypes, ...otherCommentTypes];

  return {
    title: 'Add Revision Comments',
    commentTypes,
    existingCommentsFieldName: 'revisionComments',
    placeholder: 'Select a revision comment type',
    addButtonLabel: 'Add Comment',
    saveButtonLabel: 'Save Comments',
    closeButtonLabel: 'Close',
    commentTableHeader: 'Revision Comments',
    deleteButtonIcon: 'pi pi-trash',
    includeDeleteButton: true,
  };
};
